import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col-3 col-offset-4" }
const _hoisted_4 = { class: "p-field grid" }
const _hoisted_5 = { class: "col-5" }
const _hoisted_6 = { class: "p-field grid" }
const _hoisted_7 = { class: "col-5" }
const _hoisted_8 = { class: "p-field grid" }
const _hoisted_9 = { class: "col-5" }
const _hoisted_10 = { class: "col-3 col-offset-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-3 col-offset-4" }, [
            _createElementVNode("h3", null, "Vue PlusPay - Development Mode")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                for: "firstname",
                class: "col-fixed",
                style: {"width":"100px"}
              }, "Email", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputText, {
                  style: {"width":"400px"},
                  id: "firstname",
                  name: "email",
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                  type: "text"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "lastname",
                class: "col-fixed",
                style: {"width":"100px"}
              }, "Password", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_InputText, {
                  style: {"width":"400px"},
                  id: "lastname",
                  type: "password",
                  name: "password",
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "server",
                class: "col-fixed",
                style: {"width":"100px"}
              }, "Server", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_InputText, {
                  style: {"width":"400px"},
                  id: "server",
                  type: "text",
                  name: "server",
                  modelValue: _ctx.form.server,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.server) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (!_ctx.sid)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Login",
                disabled: _ctx.isAuthenticating,
                type: "submit"
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ])
  ]))
}